import { cpp } from "@codemirror/lang-cpp";
import { html } from "@codemirror/lang-html";
import { java } from "@codemirror/lang-java";
import { javascript } from "@codemirror/lang-javascript";
import { json } from "@codemirror/lang-json";
import { python } from "@codemirror/lang-python";
import { rust } from "@codemirror/lang-rust";
import { sql } from "@codemirror/lang-sql";
import { LanguageSupport, type StreamLanguage } from "@codemirror/language";
import type { Parser } from "@lezer/common";
import { langs } from "@uiw/codemirror-extensions-langs";

import { css } from "@codemirror/lang-css";

export const languages = [
	"TypeScript",
	"JavaScript",
	"Python",
	"HTML",
	"CSS",
	"C++",
	"JSON",
	"Rust",
	"Java",
	"SQL",
	"Go",
	"Shell",
] as const;
export type Language = (typeof languages)[number];

const languageExtensions: Record<Language, LanguageSupport | StreamLanguage<unknown>> = {
	"Go": cpp(),
	"Python": python(),
	"TypeScript": javascript(),
	"JavaScript": javascript(),
	"HTML": html(),
	"CSS": css(),
	"C++": cpp(),
	"JSON": json(),
	"Rust": rust(),
	"Java": java(),
	"SQL": sql(),
	"Shell": langs.shell(),
};

export const detectLanguage = (
	language: Language | "Auto",
	code: string
): [Language, LanguageSupport | StreamLanguage<unknown>] | undefined => {
	if (language !== "Auto" && languages.includes(language)) {
		return [language, languageExtensions[language]];
	}

	const foundLanguage = languages.find((language) => {
		const extensions = languageExtensions[language];
		let parser: Parser;
		if (extensions instanceof LanguageSupport) {
			parser = extensions.language?.parser;
		} else {
			parser = extensions.parser;
		}

		if (!parser) {
			return false;
		}

		const parsed = parser.parse(code);
		const parsedString = parsed.toString();
		return parsedString.indexOf("⚠") === -1;
	});
	return foundLanguage ? [foundLanguage, languageExtensions[foundLanguage]] : undefined;
};
